
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...seoUrlPath]",
      function () {
        return require("private-next-pages/[...seoUrlPath].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...seoUrlPath]"])
      });
    }
  